import { render } from "./DeliveryAddress.vue?vue&type=template&id=73e8ef0a"
import script from "./DeliveryAddress.vue?vue&type=script&lang=js"
export * from "./DeliveryAddress.vue?vue&type=script&lang=js"

import "./DeliveryAddress.vue?vue&type=style&index=0&id=73e8ef0a&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__